export default {
	functional: true,
	name: 'RedHot',
	render(h) {
		return h('span', {
			class: 'hot-red',
		});
	},
};



// WEBPACK FOOTER //
// ./src/components/common/RedHot.js